import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const PageTitle = styled.h2`
  font-family: ${barnesTheme.fonts.heading};
  font-size: ${barnesTheme.fontSizes.xlarge};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  margin: 0 0 ${barnesTheme.spacing.smallGap} 0;

  @media print {
    font-size: ${barnesTheme.fontSizes.xlarge} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    margin: 0 0 ${barnesTheme.spacing.smallGap} 0 !important;
  }
`

export const TitleHairline = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapPlaceholder = styled.div`
  width: 100%;
  height: 260px;
  background: ${barnesTheme.colors.grege};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: ${barnesTheme.spacing.sectionGap};

  @media print {
    width: 100% !important;
    height: 260px !important;
    background: ${barnesTheme.colors.grege} !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    overflow: hidden !important;
    margin-top: ${barnesTheme.spacing.sectionGap} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media print {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }
`

export const MapPlaceholderText = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-size: ${barnesTheme.fontSizes.small} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DataSubtitle = styled.h3`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 13px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};
  margin: ${barnesTheme.spacing.sectionGap} 0 ${barnesTheme.spacing.smallGap} 0;

  @media print {
    font-size: 13px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    margin: ${barnesTheme.spacing.sectionGap} 0 ${barnesTheme.spacing.smallGap}
      0 !important;
  }
`

export const DataRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: ${barnesTheme.spacing.smallGap} 0;
  border-bottom: 1px solid ${barnesTheme.colors.border};

  &:last-child {
    border-bottom: none;
  }

  @media print {
    display: flex !important;
    align-items: baseline !important;
    justify-content: space-between !important;
    padding: ${barnesTheme.spacing.smallGap} 0 !important;
    border-bottom: 1px solid ${barnesTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    &:last-child {
      border-bottom: none !important;
    }
  }
`

export const DataLabel = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-size: ${barnesTheme.fontSizes.small} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DataValue = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.medium};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  text-align: right;

  @media print {
    font-size: ${barnesTheme.fontSizes.medium} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    text-align: right !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ZoningSection = styled.div`
  margin-top: ${barnesTheme.spacing.sectionGap};

  @media print {
    margin-top: ${barnesTheme.spacing.sectionGap} !important;
  }
`

export const ZoneItem = styled.div`
  padding: ${barnesTheme.spacing.smallGap} 0;
  border-bottom: 1px solid ${barnesTheme.colors.border};

  &:last-child {
    border-bottom: none;
  }

  @media print {
    padding: ${barnesTheme.spacing.smallGap} 0 !important;
    border-bottom: 1px solid ${barnesTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    &:last-child {
      border-bottom: none !important;
    }
  }
`

export const ZoneName = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.body};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  display: block;

  @media print {
    font-size: ${barnesTheme.fontSizes.body} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    display: block !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ZoneDetail = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  display: block;
  margin-top: 2px;

  @media print {
    font-size: ${barnesTheme.fontSizes.small} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    display: block !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* Legacy exports for backwards compatibility */
export const TwoColumnLayout = styled.div`
  display: flex;
  flex-direction: column;
`
export const RightColumn = styled.div``
export const MetricsGrid = styled.div``
export const MetricCard = DataRow
export const MetricLabel = DataLabel
export const MetricValue = DataValue
export const ParcelTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
export const ParcelTableHeader = styled.div`
  display: none;
`
export const ParcelHeaderCell = styled.span``
export const ParcelTableRow = styled.div<{ $even?: boolean }>``
export const ParcelCell = styled.span``
export const ZoneCardsRow = styled.div``
export const ZoneCard = ZoneItem
export const ZoneType = ZoneDetail
export const ZoneMetric = ZoneDetail
